export default {
  components: [
    {
      data: [
        {
          type: "logo",
          id: "aalogo",
          iconUrl: "https://static.airasia.com/design/logos/airasiacom_logo.svg",
          iconName: "",
          label: "",
          redirectUrl: "https://www.airasia.com/en/gb",
          direction: "left",
          newTab: "FALSE",
          showInMobilePane: "FALSE",
        },
        {
          type: "navigation",
          id: "promotions",
          iconUrl: "",
          iconName: "",
          label: "Passenger",
          redirectUrl: "https://www.airasia.com/ride/",
          direction: "right",
          newTab: "TRUE",
          showInMobilePane: "TRUE",
        },
        {
          type: "navigation",
          id: "flights",
          iconUrl: "",
          iconName: "",
          label: "Driver/Rider Recruitment",
          redirectUrl: "https://www.airasia.com/aa/ride/driver.html",
          direction: "right",
          newTab: "TRUE",
          showInMobilePane: "TRUE",
        },
        {
          type: "navigation",
          id: "hotels",
          iconUrl: "",
          iconName: "",
          label: "Corporate Program",
          redirectUrl: "https://www.airasia.com/aa/ride/corporate/",
          direction: "right",
          newTab: "TRUE",
          showInMobilePane: "TRUE",
        },
        {
          type: "navigation",
          id: "explore",
          iconUrl: "",
          iconName: "",
          label: "T&C",
          redirectUrl: "https://www.airasia.com/aa/about-us/en/gb/ride-terms-and-conditions.html",
          direction: "right",
          newTab: "TRUE",
          showInMobilePane: "FALSE",
        },
        {
          type: "navigation",
          id: "support",
          iconUrl: "",
          iconName: "ForumIcon",
          label: "Support",
          redirectUrl: "https://support.airasia.com/s/?language=en_GB",
          direction: "right",
          newTab: "TRUE",
          showInMobilePane: "TRUE",
        },
        // {
        //   type: "locale-currency",
        //   id: "localecurrency",
        //   iconUrl: "",
        //   iconName: "LanguageIcon",
        //   label: "",
        //   redirectUrl: "",
        //   direction: "right",
        //   newTab: "",
        //   showInMobilePane: "TRUE",
        // },
        {
          type: "login",
          id: "login",
          iconUrl: "",
          iconName: "AccountCircle",
          label: "Login/Signup",
          redirectUrl: "",
          direction: "right",
          newTab: "",
          showInMobilePane: "FALSE",
        },
      ],
    },
  ],
  defaultCurrency: [
    {
      data: [
        {
          shortform: "MYR",
          shortSymbol: "RM",
          longform: "Malaysia Ringgit",
          icon: "MonetizationOnIcon",
        },
      ],
    },
  ],
  recommendedCurrencyList: [{ data: "" }],
  currencyList: [
    {
      data: [
        { shortform: "MYR", shortSymbol: "RM", longform: "Malaysia Ringgit" },
      ],
    },
  ],
  recommendedLocaleList: [{ data: "" }],
  loginTooltip: [
    {
      data: [
        {
          title: "Log in now for BIG Member discounts",
          description:
            "Log into get BIG Member discounts and also redeem your unlimited pass",
          signupButtonText: "",
          loginButtonText: "Log in/Sign up",
        },
      ],
    },
  ],
  loginMenu: [
    {
      memberData: [
        {
          id: "bigMemberId",
          icon: "",
          label: "BIG Member ID",
          redirectUrl: "",
          newTab: "FALSE",
        },
        {
          id: "bigMemberPoints",
          icon: "",
          label: "BIG Points",
          redirectUrl: "",
          newTab: "FALSE",
        },
        {
          id: "status",
          icon: "",
          label: "Status",
          redirectUrl: "",
          newTab: "FALSE",
        },
      ],
    },
    {
      navigations: [
        {
          id: "myaccount",
          icon: "account_box",
          label: "My account",
          redirectUrl: "https://www.airasia.com/member/myaccount?culture=en-GB",
          newTab: "TRUE",
        },
        {
          id: "mybookings",
          icon: "featured_play_list",
          label: "My bookings",
          redirectUrl:
            "https://www.airasia.com/member/mybookings?culture=en-GB",
          newTab: "TRUE",
        },
        {
          id: "mysubscription",
          icon: "library_books",
          label: "My subscription",
          redirectUrl:
            "https://www.airasia.com/member/mysubscription?culture=en-GB",
          newTab: "TRUE",
        },
        {
          id: "mybigpaycheckout",
          icon: "credit_card",
          label: "My BigPay Checkout",
          redirectUrl:
            "https://www.airasia.com/member/myaccount#bigpaycheckout",
          newTab: "TRUE",
        },
        {
          id: "mycases",
          icon: "assignment_turned_in",
          label: "My cases",
          redirectUrl: "https://www.airasia.com/member/mycases?culture=en-GB",
          newTab: "TRUE",
        },
        {
          id: "mybigpoints",
          icon: "money",
          label: "My BIG Points",
          redirectUrl: "https://www.airasiabig.com/my/en/profile",
          newTab: "TRUE",
        },
        {
          id: "mycreditaccount",
          icon: "attach_money",
          label: "My credit account",
          redirectUrl:
            "https://booking2.airasia.com/CreditStatusLogin.aspx?culture=en-GB",
          newTab: "TRUE",
        },
      ],
    },
    {
      logoutButton: [
        {
          id: "logout",
          icon: "",
          label: "Log out",
          redirectionUrl: "",
          newTab: "FALSE",
        },
      ],
    },
  ],
  translations: [
    {
      data: [
        {
          settings: "Settings",
          popularCurrency: "Suggested currencies",
          popularLocale: "Popular languages",
          currency: "Choose a currency",
          locale: "Choose a language",
          otherCurrency: "Other supported currency",
          otherLocale: "Other supported languages",
          mobileLocaleLabel: "Language",
          mobileCurrencyLabel: "Currency",
        },
      ],
    },
  ],
}
